const tableHeader = [
  {value: 'manufacturer', label: 'Manufacturer'},
  {value: 'grammage', label: 'Grammage'},
  {value: 'sop', label: 'SOP(Units)'},
  {value: 'sopKg', label: 'SOP(KGs)'},
  {value: 'mix', label: 'Mix$'},
]

export { tableHeader }